import type { FC } from 'react';
import React from 'react';

// eslint-disable-next-line check-choreographer-usage/no-import-in-product-messages-without-choreographer
import Flag from '@atlaskit/flag';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';

type HeaderPresentationModeProps = {
	title: string;
};

export const ErrorFlag: FC<HeaderPresentationModeProps> = ({ title }) => {
	return (
		<Flag
			appearance="error"
			icon={<StatusErrorIcon spacing="spacious" label="Error" />}
			id="error"
			key="error"
			title={title}
		/>
	);
};
